__webpack_require__.p = "/mi-assets/mi-static/mi-legal-renderer/web-rel-26.8.3-118a138-15322/_next/";